import { render, staticRenderFns } from "./MsgPop.vue?vue&type=template&id=b54c36ac"
import script from "./MsgPop.vue?vue&type=script&lang=js"
export * from "./MsgPop.vue?vue&type=script&lang=js"
import style0 from "./MsgPop.vue?vue&type=style&index=0&id=b54c36ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports